import { createActions, createReducer } from 'reduxsauce';
import {
	cloneDeep, forEach, set, isEmpty,
} from 'lodash';

export { default as thunks } from './thunks';

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	reportData             : {},
	transactionHistoryData : [],
	loading                : {
		report      : false,
		coordinator : false,
		officer     : false,
		location    : false,
	},
	data : {
		coordinator : [],
		officer     : [],
		location    : [],
	},
	reportType      : '',
	filterPrintData : [],
};

/* ------------- Types and Action Creators ------------- */
export const { Types, Creators } = createActions({
	receiveData           : ['collection'],
	updateReports         : ['field', 'property', 'value'],
	updateStoreProperties : ['collection'],
	resetReportsData      : ['property'],
	resetReportsListData  : [],
}, { prefix : '@reports/' });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
	[Types.RECEIVE_DATA] : (state, { collection }) => {
		if (!isEmpty(collection)) {
			const newState = cloneDeep(state);

			forEach(collection, ({ property, value }) => {
				set(newState, property, value);
			});

			return newState;
		}
		return state;
	},

	[Types.UPDATE_REPORTS] : (state, { field, property, value }) => ({
		...state,
		[field] : {
			...state[field],
			[property] : value,
		},
	}),

	[Types.UPDATE_STORE_PROPERTIES] : (state, { collection }) => {
		const newState = cloneDeep(state);

		forEach(collection, (value, property) => set(newState, property, value));

		return newState;
	},

	[Types.RESET_REPORTS_DATA] : (state, { property }) => {
		const newState = cloneDeep(state);
		newState.data[property] = INITIAL_STATE.data[property];
		return newState;
	},

	[Types.RESET_REPORTS_LIST_DATA] : (state) => {
		const newState = cloneDeep(state);
		newState.reportData = INITIAL_STATE.reportData;
		newState.transactionHistoryData = INITIAL_STATE.transactionHistoryData;
		return newState;
	},
});

export default Creators;
